"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiCurrencyRateResponseDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_currency_response_dto_1 = require("./billing-api-currency-response.dto");
let BillingApiCurrencyRateResponseDto = class BillingApiCurrencyRateResponseDto extends billing_api_currency_response_dto_1.BillingApiCurrencyResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id пары",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCurrencyRateResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Курс по отношению к доллару (если меньше 1 значит дороже доллара)",
  readOnly: true,
  example: 0.921070
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Number)], BillingApiCurrencyRateResponseDto.prototype, "rate", void 0);
BillingApiCurrencyRateResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiCurrencyRateResponseDto);
exports.BillingApiCurrencyRateResponseDto = BillingApiCurrencyRateResponseDto;
